import { render, staticRenderFns } from "./GroupInfoList.vue?vue&type=template&id=197d3c9d&"
import script from "./GroupInfoList.vue?vue&type=script&lang=js&"
export * from "./GroupInfoList.vue?vue&type=script&lang=js&"
import style0 from "./GroupInfoList.vue?vue&type=style&index=0&id=197d3c9d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports